import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { RaspiPropertiesInfoPanel } from '@/features/controller/configuration/components/RaspiPropertiesInfoPanel'
import { ControllerConfigurationFileProvider } from '@/features/controller/configuration/contexts/ControllerConfigurationFileContext'
import { ControllerConfigurationBasePage } from '@/features/controller/configuration/pages/ControllerConfigurationBasePage'
import { ControllerConfigTypeId } from '@/features/controller/configuration/types'
import { RaspiPropertiesConfigType } from '@/features/controller/configuration/utils/controllerConfigTypes'
import { ControllerRouteInformation } from '@/features/controller/constants'

export function ControllerConfigurationRaspiPropertiesPage() {
  const { controllerId } = useParams()
  const { t } = useTranslation()

  if (!controllerId) {
    return null
  }

  return (
    <ControllerConfigurationFileProvider
      configTypeId={ControllerConfigTypeId.RaspiProperties}
      controllerId={controllerId}
    >
      <ControllerConfigurationBasePage
        activeTab={ControllerRouteInformation.CONTROLLER_CONFIG_RASPI_PROPERTIES.routePath}
        configType={RaspiPropertiesConfigType}
        controllerId={controllerId}
        infoPanel={<RaspiPropertiesInfoPanel />}
        pageTitle={t('controllers.configuration.raspi_properties.title')}
      />
    </ControllerConfigurationFileProvider>
  )
}
